<template>
  <div class="part-base-dialog">
    <custom-dialog class="afterSaleRole-item-dialog" width="800px" :title="model.title" :visible="visible" v-on="$listeners">
      <div class="dialog-body">
        <el-form :model="form" size="small" ref="form" label-position="top">
          <el-row :gutter="8">
            <el-col :span="16">
              <el-row :gutter="8">
                <el-col :span="12">
                  <el-form-item :label="$t('asm_part_base_dialog.ling_jian_bian_hao')" prop="partCode" :rules="rules.partCode">
                    <el-input :disabled="model.type === 'watch'" v-model="form.partCode" style="width: 100%"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item :label="$t('asm_part_base_dialog.ling_jian_ming_cheng')" prop="partName" :rules="rules.partName">
                    <el-input :disabled="model.type === 'watch'" v-model="form.partName" style="width: 100%"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item :label="$t('asm_part_base_dialog.ling_jian_gui_ge')" prop="partSpec" >
                    <el-input :disabled="model.type === 'watch'" v-model="form.partSpec" style="width: 100%"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item :label="$t('asm_part_base_dialog.dan_wei')" prop="partUnit" :rules="rules.partUnit">
                    <custom-select v-model="form.partUnit" code="after_sale_unit" :placeholder="$t('Common.com_please_select')" width="100%" :disabled="model.type === 'watch'"></custom-select>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item :label="$t('asm_part_base_dialog.ling_jian_lei_bie')" prop="partClass" :rules="rules.partClass">
                    <custom-select v-model="form.partClass" code="asm_part_class" width="100%" :placeholder="$t('Common.com_please_select')" :disabled="model.type === 'watch'"></custom-select>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item :label="$t('asm_part_base_dialog.ling_jian_lei_xing')" prop="partType" :rules="rules.partType">
                    <custom-select
                      v-model="form.partType"
                      code="asm_part_type"
                      width="100%"
                      value-type="number"
                      :placeholder="$t('Common.com_please_select')"
                      :disabled="model.type === 'watch'"
                    ></custom-select>
                  </el-form-item>
                </el-col>

                <el-col :span="12">
                  <el-row :gutter="8">
                    <el-col :span="15">
                      <el-form-item :label="$t('asm_part_base_dialog.ling_jian_dan_jia')" prop="unitPrice" :rules="rules.unitPrice">
                        <el-input :disabled="model.type === 'watch'" type="number" v-model="form.unitPrice" style="100%"></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="9">
                      <el-form-item prop="currencyUnit" :rules="rules.currencyUnit">
                        <label slot="label">&nbsp;</label>
                        <custom-select v-model="form.currencyUnit" :placeholder="$t('Common.com_please_select')" code="isynergy_cloud_currency" width="100%"></custom-select>
                      </el-form-item>
                    </el-col>
                  </el-row>
                </el-col>
                <el-col :span="12">
                  <el-form-item :label="$t('asm_part_base_dialog.fu_kuan_fang')" prop="paymentOrg" :rules="rules.paymentOrg">
                    <custom-select v-model="form.paymentOrg" code="asm_part_replace_payment_org" :placeholder="$t('Common.com_please_select')" width="100%" :disabled="model.type === 'watch'"></custom-select>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item :label="$t('asm_part_base_dialog.li_lun_shou_ming')" prop="isLifeLimit" :rules="rules.isLifeLimit">
                    <custom-select v-model="form.isLifeLimit" code="cloud_common_have" :placeholder="$t('Common.com_please_select')" width="100%" :disabled="model.type === 'watch'"></custom-select>
                  </el-form-item>
                </el-col>

                <el-col v-if="form.isLifeLimit === '1'" :span="12">
                  <el-form-item :label="$t('asm_part_base_dialog.llsyscH')" prop="theoryUseTime" :rules="rules.theoryUseTime">
                    <el-input :disabled="model.type === 'watch'" v-model="form.theoryUseTime" style="100%"></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row :gutter="8">
                <el-col :span="12">
                  <el-form-item :label="$t('asm_part_base_dialog.shi_yong_xing_hao')" prop="applyProduct">
                    <custom-select
                      url="productCodeSelectList"
                      v-model="form.applyProduct"
                      :props="{ label: 'productCode', value: 'productCode' }"
                      :placeholder="$t('Common.com_please_select')"
                      width="100%"
                      :disabled="model.type === 'watch'"
                      :multiple="true"
                    ></custom-select>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item :label="$t('asm_part_base_dialog.ling_jian_zhuang_tai')" prop="state" :rules="rules.state">
                    <custom-select v-model="form.state" code="cloud_common_state" :placeholder="$t('Common.com_please_select')" width="100%" :disabled="model.type === 'watch'"></custom-select>
                  </el-form-item>
                </el-col>
              </el-row>
            </el-col>
            <el-col :span="8">
              <div style="text-align: center; padding-top:0px">
                <!-- <el-form-item :label="label_mainImage" > -->
                <div class="title">{{ $t('asm_part_base_dialog.ling_jian_zhu_tu') }}</div>
                <t-upload
                  class="avatar-uploader"
                  type="text"
                  :disabled="model.type === 'watch'"
                  :bizId="item.partId"
                  bizType="asm.part.icon"
                  v-model="fileList"
                  :tip="$t('asm_part_base_dialog.zcJPGPNGgsdgwj2Myn')"
                  ref="partBaseItem"
                  :autoUpload="false"
                ></t-upload>
                <!-- </el-form-item> -->

              </div>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="24">
              <el-form-item :label="$t('asm_part_base_dialog.miao_shu')" prop="remark" :rules="rules.remark">
                <el-input :disabled="model.type === 'watch'" type="textarea" :rows="3" v-model="form.remark" style="width: 625px"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button v-if="model.type !== 'watch'" size="small" @click="closeDialog">{{ $t('Common.com_cancel') }}</el-button>
        <el-button v-if="model.type === 'watch'" size="small" type="primary" @click="closeDialog">{{ $t('Common.com_close') }}</el-button>
        <el-button v-else size="small" type="primary" @click="confirm">{{ $t('Common.com_confirm') }}</el-button>
      </div>
    </custom-dialog>
  </div>
</template>

<script>
import apis from '@/utils/apis';
import tUpload from '@/components/upload.vue';
import dialogMixins from '@/mixins/dialog_mixins';
import languageInjectMixins from '@/mixins/language_inject_mixins';

export default {
  mixins: [dialogMixins, languageInjectMixins],
  components: { tUpload },

  data() {
    return {
      ossConfig: {},
      item: {},
      // visible: false,
      fileList: [],
      form: {
        applyProduct: [],
        partCode: '',
        partName: '',
        unitPrice: '',
        partType: '',
        partUnit: '',
        picList: [],
        remark: '',
        // replaceMethod: '',

        partSpec: '',
        partClass: '',
        paymentOrg: '',
        isLifeLimit: '0',
        theoryUseTime: '',
        currencyUnit: '¥',
        state: '1',
      },
    };
  },
  mounted() {
    this.initDialog();
  },

  computed: {
    rules() {
      return {
        partCode: [
          {
            required: true,
            message: this.$t('asm_part_base_dialog.qtxljbh'),
          },
        ],
        partType: [
          {
            required: true,
            message: this.$t('asm_part_base_dialog.qxzljlx'),
          },
        ],
        partName: [
          {
            required: true,
            message: this.$t('asm_part_base_dialog.qsrljmc'),
          },
        ],
        unitPrice: [
          {
            required: true,
            message: this.$t('asm_part_base_dialog.qsrljdj'),
          },
        ],
        partUnit: [
          {
            required: true,
            message: this.$t('asm_part_base_dialog.qing_xuan_ze_dan_wei'),
          },
        ],
        // replaceMethod: [{ required: true, message: '请选择更换方式' }],
        applyProduct: [
          {
            type: 'array',
            required: true,
            trigger: 'blur',
            message: this.$t('asm_part_base_dialog.qxzspxh'),
          },
        ],

        partSpec: [
          {
            required: true,
            message: this.$t('asm_part_base_dialog.qtxljgg'),
          },
        ],
        partClass: [
          {
            required: true,
            message: this.$t('asm_part_base_dialog.qxzljlb'),
          },
        ],
        paymentOrg: [
          {
            required: true,
            message: this.$t('asm_part_base_dialog.qxzfkf'),
          },
        ],
        isLifeLimit: [
          {
            required: true,
            message: this.$t('asm_part_base_dialog.qxzsfyllsc'),
          },
        ],
        state: [
          {
            required: true,
            message: this.$t('asm_part_base_dialog.qxzljzt'),
          },
        ],
        theoryUseTime: [
          {
            required: true,
            message: this.$t('asm_part_base_dialog.qtxllsysc'),
          },
        ],
      };
    },
  },
  methods: {
    // 初始化
    initDialog: function () {
      this.$nextTick(() => {
        // this.visible = true;
      });
      if (this.model.type !== 'add') {
        this.item = this.model.data;
        this.getDetail();
      }
    },
    // 关闭弹窗
    closeDialog: function () {
      this.visible = false;
      setTimeout(() => {
        this.$emit('close', false);
      }, 250);
    },
    getDetail: function () {
      this.$getJSON(apis.PartInfo, { partId: this.model.data.partId }).then((res) => {
        const item = Object.assign({}, res.data);
        item.applyProduct = item.applyProduct ? item.applyProduct.split(',') : '';
        this.fileList = item.picList;
        this.item = item;
        this.$setFormatData(this.form, this.item);
        this.form.unitPrice = `${this.form.unitPrice}`;
        this.form.currencyUnit = this.item.currencyUnit || '¥';
      });
    },
    // 确认保存
    confirm: async function () {
      this.$refs.form.validate(async (valid) => {
        if (!valid) {
          return;
        }
        await this.$refs.partBaseItem.submit();

        if (this.model.type === 'add') {
          this.saveInsert();
        }
        if (this.model.type === 'edit') {
          this.saveUpdate();
        }
      });
    },
    // 保存新增
    saveInsert: function () {
      const models = this.form.applyProduct.length > 0 ? this.form.applyProduct.join(',') : '';
      const form = Object.assign({}, this.form, {
        applyProduct: models,
        picList: this.fileList,
      });
      if (this.form.isLifeLimit !== '1') {
        form.theoryUseTime = '';
      }
      this.$postJSON(apis.PartAdd, form).then(() => {
        this.$message({
          message: this.$t('Common.com_add_success'),
          type: 'success',
        });
        this.$emit('success');
        this.closeDialog();
      });
    },
    // 保存编辑
    saveUpdate: function () {
      const models = this.form.applyProduct.length > 0 ? this.form.applyProduct.join(',') : '';
      const form = Object.assign({}, this.form, {
        applyProduct: models,
        picList: this.fileList,
        partId: this.model.data.partId,
      });
      if (this.form.isLifeLimit !== '1') {
        form.theoryUseTime = '';
      }
      this.$postJSON(apis.PartUpate, form).then(() => {
        this.$message({
          message: this.$t('Common.com_edit_success'),
          type: 'success',
        });
        this.$emit('success', this.form);
        this.closeDialog();
      });
    },
  },
};
</script>

<style lang="scss">
.part-base-dialog {
  .el-upload--text {
    height: 82px;
    width: 82px;
    position: relative;
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
  }
  .upload-bd .el-upload--text {
    width: 178px;
    height: 178px;
    .el-icon-plus {
      font-size: 28px;
    }
  }
  .title {
    color: rgba(0, 0, 0, 0.85);
    font-weight: bold;
    line-height: 24px;
    font-size: 16px;
    margin-bottom: 24px;
  }
  .left {
    border-right: 1px solid #eef2f8;
    padding-right: 24px;
  }
  .right {
    padding-left: 24px;
  }
  .el-form-item--small.el-form-item {
    margin-bottom: 14px;
  }
  .title {
          font-size: 12px;
    color: #495057;
    font-weight: 500;
    line-height: 24px;
    padding-bottom: 4px !important;
    padding-left: 0 !important;
    width: 100%;
    text-align: left;
    font-weight: bold;
    margin-bottom: 0;
    }
}
</style>
